import { i18n } from "@/lib/i18n";

/**
 * The usage window of the home page, in days: today and the 6 days before
 * it, Belgian time, as on the Analytics page's default period. A rolling
 * window, not the calendar week, so the page calls it "Afgelopen 7 dagen".
 */
export const USAGE_DAYS = 7;

/**
 * The name of a rolling window of `days` days (today and the days before it),
 * in the dashboard's language: "Afgelopen 7 dagen", "Last 7 days". Never
 * "This week": on a Monday such a window is mostly the week before, weekend
 * included.
 */
export function lastDaysLabel(days: number): string {
  return i18n.t("usage.lastDays", { count: days });
}
